export default [
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
];
